import { Discounts } from '@prisma/client';

export function convertDiscountAmountToDisplay(discount: Discounts) {
  return discount && discount.type === 'PERCENTAGE'
    ? discount.amount * 100
    : (discount?.amount || 0) / 100;
}

export function getDiscountLabel(discount: Discounts) {
  return `${discount.name}${discount.code ? ` (${discount.code})` : ''}`;
}
